import store from '../store/store'
import {mapPropertyFromStore, mapPropertiesFromStore} from "./mapOperators";

export const mapProperty = mapPropertyFromStore(store)
export const mapProperties = mapPropertiesFromStore(store)